import { render } from "./TopicFilterBar.vue?vue&type=template&id=34b6a225&scoped=true"
import script from "./TopicFilterBar.vue?vue&type=script&lang=js"
export * from "./TopicFilterBar.vue?vue&type=script&lang=js"

import "./TopicFilterBar.vue?vue&type=style&index=0&id=34b6a225&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b6a225"]])

export default __exports__